define(["require", "exports", "jquery"], function (require, exports, $) {
    "use strict";
    exports.__esModule = true;
    function default_1(firstName, credit, coupon, onCloseNavigate) {
        var dlgClassName = "welcome-credit-dialog";
        var $dlg = $(dlgClassName);
        var welcomeTitle = "<h3 class=\"title\">Welcome to celuce.com!</h3>";
        var welcomeCoupon = coupon && coupon.saving > 0 ? "<li>Please Check your email for your welcome coupon to save $" + coupon.saving.toFixed(0) + " off your first purchase of $" + coupon.amount.toFixed(0) + ".</li>" : '';
        var welcomeCredit = credit > 0 ? "<li>Plus, enjoy $" + credit.toFixed(0) + " reward points for fabric samples (automatically applied at checkout).</li>" : '';
        var welcomeActions = "<div><button class=\"email-signup\" type=\"submit\">SHOP NOW</button></div>";
        var welcomeMessage = "<p>" + firstName + ", welcome to CELUCE.</p><ul>" + welcomeCoupon + welcomeCredit + " </ul>";
        if ($dlg.length === 0) {
            $dlg = $("<div class=\"" + dlgClassName + "\">" + welcomeMessage + welcomeActions + "</div>");
            $dlg.appendTo($('body'));
            $dlg.find('.email-signup').click(function (evt) {
                $dlg.dialog('close');
            });
        }
        $dlg.data('onCloseNavigate', onCloseNavigate || '/');
        $dlg.dialog('show');
    }
    exports["default"] = default_1;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/dialogs/welcomeCredit.js
// module id = 11
// module chunks = 0